import Vue from 'vue'

let dropData

const isChildOf = (el, t) => {
  return el === t || (el && el.parentElement ? isChildOf(el.parentElement, t) : false)
}

/**
 *
 * @param {Element} el
 * @param {string} type
 * @param {function} handler
 * @param opt
 */
const addEvent = (el, type, handler, opt = {}) => {
  el.__lwfEvents = el.__lwfEvents || []
  el.__lwfEvents.push({
    type,
    handler
  })
  el.addEventListener(type, handler, opt)
}

/**
 * Retire tous les events lwf
 * @param {Element} e
 */
const clearEvents = (e) => {
  (e.__lwfEvents || []).forEach((ev) => e.removeEventListener(ev.type, ev.handler))
}

const Draggable = {
  bind (...args) {
    Draggable.update(...args)
  },

  update (el, binding) {
    el.draggable = true
    const onDragStart = (e) => {
      dropData = binding.value && binding.value.dropData
      e.dataTransfer.setData('text', 'data')
      e.dataTransfer.dropEffect = 'move'
    }

    const onDragStop = (e) => {
      dropData = null
    }

    clearEvents(el)
    addEvent(el, 'dragstart', onDragStart)
    addEvent(el, 'dragstop', onDragStop)
    addEvent(el, 'dragend', onDragStop)
  }
}
Vue.directive('drag', Draggable)

/**
 * Verifie qu'il y a dropData
 * @param listener
 * @returns {*}
 */
const hasDropData = (listener) => (e) => dropData ? listener(e) : null
const Droppable = {
  bind (...args) {
    Droppable.update(...args)
  },

  update (el, binding) {
    el.droppable = true

    const { value, dropClass = 'drop-valid' } = binding
    const _onDrop = (value && value.onDrop) || (() => {})
    const targetData = (value && value.targetData)

    const onDragLeave = (e) => {
      if (!isChildOf(e.relatedTarget, el)) el.classList.remove(dropClass)
    }

    const onDragOver = (e) => {
      el.classList.add(dropClass)
      e.preventDefault()
    }

    const onDrop = (e) => {
      e.preventDefault()

      // don't drop on other draggables
      if (e.target.draggable === true) {
        return
      }

      _onDrop(e, {
        dropData,
        targetData
      })

      el.classList.remove(dropClass)
    }

    clearEvents(el)

    addEvent(el, 'dragleave', hasDropData(onDragLeave), false)
    addEvent(el, 'dragover', hasDropData(onDragOver), false)
    addEvent(el, 'drop', hasDropData(onDrop), false)
  }
}

Vue.directive('drop', Droppable)
